<template>
    <div class="background">
        <span class="word" style="width: 50px" @click="preview">&lt;</span>
        <span v-for="i in currentTotal" :key="i" class="word" :style="{color: getColor(words[currentPage*10+i-1])}" @click="submitWord(words[currentPage*10+i-1])">{{words[currentPage*10+i-1].content1}}</span>
        <span class="word" @click="nextview" style="width: 50px;position: absolute; right:0;top: 75px">></span>
    </div>
</template>
<script>
export default {
    props: ['newword','learnProgress'],
    data: function() {
        return{
            words: [],
            currentPage: 0,
            currentTotal: 0,
            total: 0,
            totalPage: 0,
        }
    },
    watch: {
        newword: function (n) {
            if (n!=null) {
                if (this.contain(this.words,n)) {
                    this.words.splice(this.words.indexOf(n),1);
                }
                this.words.unshift(n)
                this.total = this.words.length
                this.totalPage = this.total%10==0?Math.floor(this.total/10):Math.floor(this.total/10+1),
                this.currentTotal = this.total<10?this.total:10;
            }
        }
    },
    methods: {
        contain(arr, item) {
            let flag = false;
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                flag = true
                }
            }
            return flag
        },
        getColor(word) {
            if (this.contain(this.learnProgress.miss, word)) {
                return '#ac1a1a'
            } else if (this.contain(this.learnProgress.unsure, word)) {
                return '#ac681a'
            } else {
                return '#334970ee'
            }
        },
        preview() {
            if (this.currentPage>0) {
                this.currentTotal = 10;
                this.currentPage--;
            }
        },
        nextview() {
            if (this.currentPage<this.totalPage-1) {
                this.currentTotal = this.currentPage+2>=this.totalPage?this.total%10:10;
                this.currentPage++
            }
        },
        submitWord(word) {
            this.$emit('clickHistoryWord',word)
        }
    }
}
</script>
<style scoped>
.background{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 3em;
}
.word{
    margin: auto 0.5%;
    width: 8%;
    height: 2em;
    background: #FFF;
    border-radius: 0.3em;
    font-size: 1.2em;
    line-height: 2em;
    padding: 10px auto;
    overflow: auto;
    text-align: center;
}
</style>